@let contactData = contact();
<aside class="dialog" fxLayout="column">
  <mat-toolbar color="primary">
    <h2 class="dialog__title">
      <div class="title" fxLayout fxLayoutAlign="start center">
        @if (media.isActive('gt-xs')) {
          <qt-avatar
            [imageId]="avatarReferenceId()"
            [name]="firstName()"
            [statusCode]="statusCode()"
            [referenceType]="personReferenceType"></qt-avatar>
        }
        <span>{{ personData()?.name }}</span>
      </div>
    </h2>
    <span fxFlex></span>
    <button mat-icon-button [matMenuTriggerFor]="menurel" class="m-0">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menurel="matMenu">
      <button mat-menu-item (click)="onEdit()">
        <mat-icon>mode_edit</mat-icon>
        <span>{{ 'CMD_EDIT' | translate }}</span>
      </button>
      <button mat-menu-item (click)="onInvite()">
        <mat-icon>contact_mail</mat-icon>
        <span>{{ 'CMD_CNT_REINVITE' | translate }}</span>
      </button>
    </mat-menu>
    <button mat-icon-button matDialogClose class="m-0">
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>
  <mat-dialog-content>
    <div fxLayout="column" fxLayoutGap="1rem" class="content">
      <h2 class="mat-headline-6">{{ 'GNR_CNT_DETAILS' | translate }}:</h2>
      <div fxLayout="column" fxLayoutGap="1rem" ngClass.gt-xs="px-3">
        @if (companyData()?.companyName) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'FTR_REL_CMP_NAME' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">domain</mat-icon>
            <span class="content__line">{{ companyData()?.companyName }}</span>
          </section>
        }
        <section
          fxLayout
          fxLayoutGap="1rem"
          fxLayoutAlign="start center"
          [matTooltip]="'GNR_REL' | translate"
          matTooltipPosition="above">
          <mat-icon class="material-icon-gray">swap_horiz</mat-icon>
          <div fxLayout="column">
            <span class="content__line">{{ relation | translate }}</span>
            @if (role()) {
              <span class="mat-caption">{{ role() | translate }}</span>
            }
          </div>
        </section>
        @if (companyData()?.address && companyData()?.address.street) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'CMP_ADDRESS' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">place</mat-icon>
            <div fxLayout="column">
              <span class="content__line">{{
                companyData()?.address.street
              }}</span>
              <span class="content__line">{{
                companyData()?.address.city +
                  ' ' +
                  companyData()?.address.state +
                  ' ' +
                  companyData()?.address.zipCode
              }}</span>
            </div>
          </section>
        }
        @if (contactData.email) {
          <section
            fxLayout
            fxLayoutGap="1rem"
            fxLayoutAlign="start center"
            [matTooltip]="'GNR_EMAIL' | translate"
            matTooltipPosition="above">
            <mat-icon class="material-icon-gray">email</mat-icon>
            <span class="content__line">{{ contactData.email }}</span>
          </section>
        }
        @if (personData()?.phoneList) {
          <section
            fxLayout="column"
            fxLayoutGap="1rem"
            [matTooltip]="'GNR_PHNNO' | translate"
            matTooltipPosition="above">
            @for (
              phone of personData()?.phoneList;
              track phone;
              let index = $index
            ) {
              <div fxLayout fxLayoutGap="1rem" fxLayoutAlign="start center">
                <mat-icon class="material-icon-gray">{{
                  phone.type === PhoneType.MOBILE ? 'phone_iphone' : 'phone'
                }}</mat-icon>
                <span>{{ phone.number | phone: phone.countryCode }}</span>
                <!--            <span [ngClass]="{-->
                <!--                content__line: true,-->
                <!--                'content__line&#45;&#45;margin': index !== 0-->
                <!--              }">{{ phone.number | phone: phone.countryCode:true }}</span>-->

                @switch (phone.type) {
                  @case ('MOBILE') {
                    <span class="mat-caption">{{
                      'GNR_CELL_PHONE' | translate
                    }}</span>
                  }
                  @case ('WORK') {
                    <span class="mat-caption">{{
                      'GNR_WORK_PHONE' | translate
                    }}</span>
                  }
                  @default {}
                }
              </div>
            }
          </section>
        }
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout fxLayoutAlign="end">
    <button mat-button matDialogClose>{{ 'CMD_CLOSE' | translate }}</button>
  </mat-dialog-actions>
</aside>
